import { DiscountDTO } from "../models/cart/item.model";

export class DiscountVO {
  readonly value: number;
  readonly type: 'fixed' | 'percentage';
  private calculatedValue: number;

  constructor(data?: DiscountDTO) {
    this.value = data?.value ?? 0;
    this.type = data?.type ?? 'fixed';
    this.calculatedValue = data?.calculatedValue ?? 0;
  }

  apply(subtotal: number): number {
    const discount = this.computeDiscount(subtotal);

    this.calculatedValue = discount;

    return subtotal - discount;
  }

  private computeDiscount(baseAmount: number): number {
    if (this.value <= 0 || baseAmount <= 0) {
      return 0;
    }

    if (this.type === 'fixed') {
      return Math.min(this.value, baseAmount);
    }

    const percentage = Math.max(0, Math.min(100, this.value));
    const discount = baseAmount * (percentage / 100);

    return Math.min(discount, baseAmount);
  }

  equals(other?: DiscountVO): boolean {
    if (this === other) {
      return true;
    }

    if (!other) {
      return false;
    }

    if (this.value === 0 && other.value === 0) {
      return true;
    }

    return this.value === other.value && this.type === other.type;
  }

  toDTO(): DiscountDTO | undefined {
    if (this.value <= 0) {
      return undefined;
    }

    return {
      value: this.value,
      type: this.type,
      calculatedValue: this.calculatedValue,
    };
  }

  static areDTOsEqual(a?: DiscountDTO, b?: DiscountDTO): boolean {
    const left = new DiscountVO(a);
    const right = new DiscountVO(b);

    return left.equals(right);
  }
}
